/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from "axios";
import { Result } from "../../../Shared/Protocol/protocol-result";
import { ICreateCustomerPaymentPreferencePayload, IDestroyCustomerPaymentPreferencePayload, IUpdateCustomerPaymentPreferencePayload } from "./customer-payment-preferences.interface";

export class CustomerPaymentPreferencesApiRemoteService {
  constructor(private service: AxiosInstance) {}

  public update = async ({ id, preference, customerId }: IUpdateCustomerPaymentPreferencePayload): Promise<Result<void>> => {
    try {
        const response = await this.service.put(`/customers/${customerId}/payment-preferences/${id}`, {...preference});

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public create = async ({ customerId, preference}: ICreateCustomerPaymentPreferencePayload): Promise<Result<void>> => {
    try {
        const response = await this.service.post(`/customers/${customerId}/payment-preferences`, { ...preference });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

//   public show = async (variantId: string): Promise<Result<ICubageVariantEntity>> => {
//     try {
//         const response = await this.service.get(`/cubages/variants/${variantId}`);

//       return Result.ok(response.data);
//     } catch (error: any) {
//       return Result.fail(error?.response?.data ?? error);
//     }
//   };

  public destroy = async ({ customerId, id}: IDestroyCustomerPaymentPreferencePayload): Promise<Result<void>> => {
    try {
        const response = await this.service.delete(`/customers/${customerId}/payment-preferences/${id}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

//   public list = async (page: number): Promise<Result<ICubageEntity[]>> => {
//     try {
//         const response = await this.service.get(`/cubages`);

//       return Result.ok(response.data);
//     } catch (error: any) {
//       return Result.fail(error?.response?.data ?? error);
//     }
//   };
}
